import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Degree from './degree';
import FocusList from './focus-list';

const getDegreesAndFocuses = (data) => {
	if (
		// We only want to show the sublist if at least one of these properties exist.
		!_.some([
			'degree_name',
			'grad_date',
			'distinction',
			'school_latin_honors',
			'school_honors',
			'school_majors',
			'school_minors',
		], prop => data[prop])
	) {
		return null;
	}

	const distinction = data.distinction ? <li>Honors: <em>{data.distinction.toLowerCase()}</em></li> : null;

	return (
		<ul>
			<Degree name={data.degree_name} date={data.grad_date} />
			{distinction}
			<FocusList prefix="Honors:" items={data.school_latin_honors} />
			<FocusList prefix="Honors:" items={data.school_honors} />
			<FocusList prefix="Major:" items={data.school_majors} />
			<FocusList prefix="Minor:" items={data.school_minors} />
		</ul>
	);
};

const School = ({ data }) => {
	const city = data.city ? <span>, {data.city}</span> : '';
	const state = data.state ? <span>, {data.state}</span> : '';

	return (
		<li className="bio-list__item">
			<strong>{data.school}</strong>
			{city}
			{state}
			{getDegreesAndFocuses(data)}
		</li>
	);
};

School.propTypes = {
	data: PropTypes.object.isRequired,
};

export default School;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/school.js